import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  const { action, location } = useHistory();

  useEffect(() => {
    if (action !== 'POP' && !location?.state?.disableScroll) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
